import React, { createContext, useState } from 'react'
import PropTypes from 'prop-types'
import usePartner from '../../hooks/usePartner'

export const initialContext = {
  env: 'prod',
  isEnabled: false,
  isSignedIn: false,
  profile: {
    fields: {},
    data: {}
  }
}

export const SSOContext = createContext(initialContext)

function SSOProvider ({ env, children }) {
  const ssoConfig = usePartner('config.sso')
  const [isSignedIn, setIsSignedIn] = useState(ssoConfig?.isSignedIn === true)
  let profileData

  if (ssoConfig?.isEnabled && isSignedIn) {
    profileData = usePartner('profile')
  }

  const props = {
    env,
    ...ssoConfig,
    isSignedIn,
    profile: {
      ...(ssoConfig?.profile || {}),
      data: {
        ...(ssoConfig?.profile?.data || {}),
        ...(profileData || {})
      }
    },
    handleSignOut: callback => {
      setIsSignedIn(false)
      typeof callback === 'function' && callback()
    }
  }

  return <SSOContext.Provider value={props}>{children}</SSOContext.Provider>
}

SSOProvider.displayName = 'SSOProvider'

SSOProvider.propTypes = {
  env: PropTypes.string,
  children: PropTypes.node
}

export default SSOProvider
